export function formatNumber2(value) {
  if (value === null || value === undefined) return '';
  const n = Number(value);
  if (Number.isNaN(n)) return '';

  // redondea a 2 decimales y elimina .00 si es entero
  return Number(n.toFixed(2)).toString();
}